const jimuUrl = {
  state: {
    baseUrl: process.env.VUE_APP_MAIN_URL,
  },
  
  mutations: {
  }
}
export default jimuUrl
